export default __webpack_public_path__ + "static/media/zoom-in.1d48c523.svg";